// extracted by mini-css-extract-plugin
export default {"root":"CategoryBrowseBackground-module__root___WeKzq","datingBackground":"CategoryBrowseBackground-module__datingBackground___1epjb"};